/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable promise/always-return */
/**
 * Product methods
 * -----------------------------------------------------------------------------
 *
 * @namespace product
 */

import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fullscreen';
import enquire from 'enquire.js';
import scrollMonitor from 'scrollmonitor';

const productMethods = {

  data() {
    return {
      enableHistoryState: false,
      isProductToolbarMobileOpen: false,
      product: {},
      currentVariant: {},
    };
  },

  methods: {

    /**
     * Product Single
     */
    _initProduct() {
      const $container = $('[data-template="product"]');
      const $productTabs = $(app.selectors.productTabs);
      const $imageZoom = $(app.selectors.imageZoom);
      const productObj = app.selectors.productObj;

      // product tabs add active class to 1st child
      $productTabs.find('.nav-item').first().find('a')
        .addClass('active');
      $productTabs.find('.tab-content .tab-pane').first().addClass('active');

      // stop parsing if we are not in the product template
      if (app.currentTemplate !== 'product') {
        return;
      }

      // set data
      app.product = JSON.parse($(productObj).html());
      const productData = JSON.parse($(productObj).html());
      app.product = productData.product;
      app.product.options_with_values = productData.options_with_values;

      // assign the product cart limit
      app.product.tags.forEach((tag) => {
        if (tag.match('cart-limit')) {
          const cartLimit = tag.replace('cart-limit-', '');
          app.product.cart_limit = parseFloat(cartLimit);
        }
      });

      app.enableHistoryState = $container.data('enable-history-state');
      app._getVariant();
    },

    /**
     * Event when product option select or input changes
     *
     */
    _getVariant(event, eventType) {
      let variant;
      if (eventType == undefined) {
        eventType = 'normal product';
      }
      if (eventType == 'addon product') {
        app._getCurrentProd($(event.currentTarget).closest('[data-product-addon-id]').attr('data-product-addon-id'));
      }

      $('.size-swatch input').on('click', (e) => {
        if (app.pro_Available_flag) {
          $('.size_swatch input').attr('disabled', true);
          $('.addtocartmessage').removeClass('d-none');
          const $select_v_title = $('.service-product form[data-product-form] .size-swatch input');
          $select_v_title.each(function () {
            $(this).prop('checked', false);
          });
        } else {
          $('.size_swatch input').attr('disabled', false);
        }
      });
      if (!app.pro_Available_flag) {
        $('.size_swatch input').attr('disabled', false);
      }

      variant = app._getVariantFromOptions(event, eventType);
      if (eventType == 'addon product') {
        app.productAddons.currentVariant = variant;
        app.productAddons.selectedVariant.push(variant);
        let totalAddon = 0.00;
        app.productAddons.selectedProduct.forEach((x) => {
          // console.log('x before', x, variant);
          if (x.product_id == variant.product_id) {
            x.variant_id = variant.id;
            x.variant_price = variant.price;
            x.variant_title = variant.option1;
          }
          // console.log('x after', x, variant);
          totalAddon += parseFloat(x.variant_price) * 100;
        });

        app.productAddons.totalValue = totalAddon;
        $(`[data-product-addon-id="${app.productAddons.currentVariant.product_id}"] [data-product-price]`).html(app._formatMoney(app.productAddons.currentVariant.price));
        return;
      }

      // stop parsing if there is no variant info
      if (!variant) {
        app.currentVariant = {};
        return;
      }

      app._updateImages(variant, event);

      if (app.currentTemplate === 'collection') { // collection
        const productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        const product = app.collection.products.find((x) => x.id === productId);
        product.current_variant = variant;

      } else if (app.currentTemplate === 'product') {
        app.currentVariant = variant;

        axios.get(`/products/${app.product.handle}?variant=${variant.id}&view=currentvariant.json`)
          .then((response) => {
            app.meta_days = response.data.days;
          });

        if (app.enableHistoryState) {
          app._updateHistoryState(variant);
        }

        // Recharge code start
        // ReCharge Integration for the product page
        // Update data needed for ReCharge when variant changes
        const discountVariantId = $(`[data-variant-id="${variant.id}"]`).attr('data-discount-variant-id');
        app.reChargeDiscountVariantId = discountVariantId;
        // Recharge code end
      }
    },
    /**
     * Get the currently selected options from add-to-cart form.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions(event, eventType) {
      let singleOptionSelector;
      const currentOptions = [];
      let $container;

      if (event != undefined && eventType == 'addon product') { singleOptionSelector = $(event.currentTarget); } else { singleOptionSelector = app.selectors.singleOptionSelector; }

      if (event != undefined && eventType == 'addon product') { $container = $(event.currentTarget).closest('[data-product-addon-form]'); } else {
        $container = event ? $(event.currentTarget).closest(app.selectors.productForm) : $(app.selectors.productForm);
      }

      $.map($(singleOptionSelector, $container), (element) => {
        const $element = $(element);
        const type = $element.attr('type');
        const currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            currentOptions.push(currentOption);
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          currentOptions.push(currentOption);
        }
      });

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions(event, eventType) {
      const selectedValues = app._getCurrentOptions(event, eventType);
      let variants;
      let found = false;

      if (app.currentTemplate === 'collection') { // collection
        const productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        const product = app.collection.products.find((x) => x.id === productId);
        variants = product.variants;
      } else if (app.currentTemplate === 'product') { // product
        if (event != undefined && eventType == 'addon product') {
          variants = app.productAddons.currentProduct.variants;
        } else {
          variants = app.product.variants;
        }
      }

      variants.forEach((variant) => {
        let satisfied = true;

        selectedValues.forEach((option) => {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      let newUrl;

      const showReviewForm = app._getUrlParameter('showReviewForm');

      if (showReviewForm === '') {
        newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}`;
      } else {
        newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}&showReviewForm=${showReviewForm}`;
      }

      window.history.replaceState({
        path: newUrl,
      }, '', newUrl);
    },

    /**
     * Find variant image and scroll to this image
     * works for all product page templates
     * can be extended to update all images upon variant selection
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateImages(variant, event) {
      const variantImage = variant.featured_image || {};
      const variantTitle = variant.title;
      const templateType = $('[data-product-template]').data('product-template');
      const $scrollTarget = $(`[data-variant-title="${variantTitle}"]`);
      let $container;
      let currentVariantImage;

      if (app.currentTemplate === 'collection') {
        $container = $(event.currentTarget).closest(app.selectors.productForm);
        const productId = $container.data('product-id');
        const product = app.collection.products.find((x) => x.id === productId);
        if (product.current_variant.featured_image) {
          currentVariantImage = product.current_variant.featured_image.src || {};
        } else {
          currentVariantImage = product.featured_image || {};
        }
      } else if (app.currentTemplate === 'product') {
        $container = $('[data-template="product"]');
        currentVariantImage = app.currentVariant.featured_image || {};
      }

      const $carousel = $container.find('[data-carousel-main]');

      if (variantImage.src === currentVariantImage.src) {
        return;
      }

      if ($carousel.length > 0) {
        const flkty = Flickity.data($carousel[0]);

        if (typeof flkty === 'undefined') {
          return;
        }

        const cellElements = flkty.getCellElements();
        cellElements.forEach((element, index) => {
          const imgAlt = $(element).data('variant-title');
          if (variantTitle.indexOf(imgAlt) !== -1) {
            flkty.selectCell(index, true, false); // value, isWrapped, isInstant
          }
        });
      }
    },

    _getCurrentProd(productID) {
      // eslint-disable-next-line radix
      productID = parseInt(productID);
      app.productAddons.currentProduct = app.productAddons.products.find((product) => productID === product.id);
    },

  },
};

export default productMethods;

